import React from "react";
import { Field, Formik, FormikHelpers } from "formik";
import { Button } from "~/components/Button";

import { Form, FormColumn, FormControls, FormRow, FormTitle, InputField, IntentText } from "~/components/Form";
import { IModalComponent, IModalComponentClose } from "~/components/Modal";
import { Intent } from "~/lib/intent";
import { FormNotice } from "~/components/FormNotice/FormNotice";
import { renderDollars } from "~/lib/helpers";

interface IForcePayFrom {
  sellerName: string;
  onSubmit: (formikActions: FormikHelpers<never[]>, close?: IModalComponentClose) => void;
  scheduledPayout: number;
}

export const ForcePayForm: IModalComponent<IForcePayFrom> = (props) => {
  return (
    <Formik initialValues={[]} onSubmit={(_data, actions) => props.onSubmit(actions, props.close)}>
      {(formik) => {
        const { status, isSubmitting } = formik;
        return (
          <Form>
            <FormTitle>Force pay for {props.sellerName}</FormTitle>

            {status && <IntentText intent={Intent.DANGER}>{status}</IntentText>}
            <FormNotice message="Only use if you don't use Trolley as payment method" />

            <FormRow noBorder>
              <FormColumn>
                <Field
                  name="scheduledPayout"
                  label="Scheduled payout"
                  options={{
                    disabled: true,
                  }}
                  value={renderDollars(props.scheduledPayout)}
                  component={InputField}
                />
              </FormColumn>
            </FormRow>

            <FormControls>
              <Button disabled={isSubmitting} onClick={props.close}>
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={isSubmitting}
                intent={Intent.PRIMARY}
                rightIcon={isSubmitting && <i className="fa fa-spinner fa-spin" />}
              >
                Force pay
              </Button>
            </FormControls>
          </Form>
        );
      }}
    </Formik>
  );
};
